<template>
    <main>
        <router-view />
    </main>
    <ChatBot v-if="!isChatRoute" />
</template>

<script>
import ChatBot from "@/components/Bot/ChatBot.vue";

export default {
    name: 'MainLayout',
    components: { ChatBot },
    computed: {
        isChatRoute() {
            return this.$route.path === '/chat';
        }
    }
};
</script>
